import ApolloClient from 'apollo-client';

import cache from './cache';
import link from './links';

const client = new ApolloClient({
  link,
  cache,
});

export default client;



// WEBPACK FOOTER //
// ./src/data/client.js